var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47702 0 0 4.47702 0 10C0 15.523 4.47702 20 10 20C15.523 20 20 15.523 20 10C20 4.46909 15.523 0 10 0ZM10 3.85895C6.61648 3.85895 3.86688 6.60855 3.86688 9.99207C3.86688 10.5071 3.44692 10.9271 2.93186 10.9271C2.41681 10.9271 1.99682 10.5071 1.99682 9.99207C1.99682 5.57844 5.58637 1.9889 10 1.9889C10.5151 1.9889 10.935 2.40888 10.935 2.92393C10.935 3.43899 10.5151 3.85895 10 3.85895Z",
    fill: "#FFD862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.f0969ce14dda7784e591d1c634441595.svg";
export { ForwardRef as ReactComponent };